import { jsx } from 'react/jsx-runtime';
import { useField } from 'formik';
import { ButtonSelector } from '../ButtonSelector/ButtonSelector.js';

function ButtonSelectorField(props) {
  const [{
    value
  }, meta, {
    setValue
  }] = useField({
    name: props.name,
    validate: props.validate
  });
  let errorMessage = '';
  if (meta.touched && meta.error) {
    errorMessage = meta.error;
  }
  return jsx(ButtonSelector, {
    ...props,
    error: errorMessage,
    onChange: v => {
      props.onChange?.(v);
      setValue(v);
    },
    value: value
  });
}

export { ButtonSelectorField };
